import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";

import { identityFields } from "./fields/identity";
import { contentFields } from "./fields/content";
import { pricingFields } from "./fields/pricing";
import { assetsFields } from "./fields/assets";
import { metadataFields } from "./fields/metadata";

// Field order below mirrors the original object literal insertion order.
// Do not reorder — consumers depend on iteration order (column order, form layout, etc.).
export const coreOfferingsFields: Record<string, SimpleFieldConfig> = {
  title: identityFields.title,
  description: contentFields.description,
  executive_summary: contentFields.executive_summary,
  cta_href: contentFields.cta_href,
  cta_text: contentFields.cta_text,
  pricing_model: pricingFields.pricing_model,
  base_price: pricingFields.base_price,
  pricing_display: pricingFields.pricing_display,
  linked_project_slug: identityFields.linked_project_slug,
  tags: identityFields.tags,
  staff_line_items: pricingFields.staff_line_items,
  hard_cost_line_items: pricingFields.hard_cost_line_items,
  total_hours: pricingFields.total_hours,
  total_hard_costs: pricingFields.total_hard_costs,
  total_cost: pricingFields.total_cost,
  image_url: assetsFields.image_url,
  one_pager_pdf_url: assetsFields.one_pager_pdf_url,
  delivery_kit: assetsFields.delivery_kit,
};

export const metadataOfferingsFields: Record<string, SimpleFieldConfig> = {
  created_by: metadataFields.created_by,
  created_at: metadataFields.created_at,
  updated_at: metadataFields.updated_at,
};
